// src/shared/utils/dateHelpers.js
//
// Date predicates shared by DatePicker and its callers. Separate from the
// component so the file stays component-only for react-refresh, the same
// split colorScales.js uses for ScoreBar/ScoreRing.

const ISO_DATE = /^\d{4}-\d{2}-\d{2}$/;

/** True when `value` is a usable ISO `YYYY-MM-DD` string. */
export function isIsoDate(value) {
  return typeof value === "string" && ISO_DATE.test(value);
}

/**
 * Why a start/end pair is invalid, or null when it is fine.
 *
 * String comparison is correct here: ISO dates sort lexicographically, so
 * no Date parsing (and no timezone surprise) is needed. Returns null when
 * either side is missing -- an incomplete range is not yet wrong.
 */
export function dateRangeError(start, end) {
  if (!isIsoDate(start) || !isIsoDate(end)) return null;
  if (end < start) return "End date cannot be earlier than the start date.";
  return null;
}
